// extracted by mini-css-extract-plugin
export default {"container":"myProfile_container__7tCJb"};